import type { ReactNode } from 'react';

import { NotYet, type NotYetKey } from './not-yet';

/**
 * A headline number (dataviz stat tile): label in sentence case, then the value
 * in the UI sans, semibold, auto-compacted by the caller, with proportional
 * figures. An optional note sits under it. `notYet`: it does not work in this
 * version, so it shows faded, with the info mark level with the label.
 */
const StatTile = ({ label, value, note, title, notYet }: { label: string; value: string; note?: ReactNode; title?: string; notYet?: NotYetKey }) => {
  const tile = (
    <div className="rounded-card bg-surface p-4 shadow-e1" title={title}>
      <p className={notYet ? 'pr-6 text-sm text-fg-muted' : 'text-sm text-fg-muted'}>{label}</p>
      <p className="mt-1 text-2xl font-semibold text-fg-strong">{value}</p>
      {note && <p className="mt-1 text-xs text-fg-faint">{note}</p>}
    </div>
  );
  return notYet ? (
    <NotYet what={notYet} info="right-4 top-[18px]">
      {tile}
    </NotYet>
  ) : (
    tile
  );
};

export default StatTile;
